import "./DashboardCard.css";

export default function DashboardCard({ icon, label, value, description }) {
  return (
    <div className="dashboard-card">
      {icon && <div className="dashboard-card__icon">{icon}</div>}

      <div className="dashboard-card__content">
        <span>{label}</span>
        <strong>{value ?? 0}</strong>

        {description && <p>{description}</p>}
      </div>
    </div>
  );
}
